{
  "actions": {"handOff": "Übergeben …", "reopen": "Wieder öffnen"},
  "composer": {
    "add": "Einfügen…",
    "addSearch": "Artefakt oder Werkzeug zum Einfügen finden",
    "cancelTurn": "Abbrechen",
    "cancelling": "Wird abgebrochen …",
    "cannotWrite": {
      "closed": "Dieser Durchlauf ist geschlossen. Forken Sie ihn, um weiterzumachen.",
      "savedNotHost": "Dieser Durchlauf ist nicht verbunden: Der PC, auf dem er läuft, ist offline, also kann nur die Person schreiben, der er gehört. Forken Sie ihn, um selbst weiterzumachen."
    },
    "hostChoosesAgent": "{{name}} hat noch keinen Agenten gewählt.",
    "label": "Nachricht",
    "outlook": {
      "cannotRun": "Der Agent kann auf dem PC, auf dem der Durchlauf läuft, nicht antworten: {{reason}}.",
      "joinsAfterApproval": "Ein Werkzeug wartet auf seine Freigabe auf dem PC, auf dem der Durchlauf läuft. Ihre Nachricht wartet und geht mit, sobald dieser Schritt gelaufen ist.",
      "joinsAfterSlot": "Der Zug wartet auf freie Kapazität auf dem PC, auf dem der Durchlauf läuft, und startet von selbst. Ihre Nachricht wartet und geht mit dem Zug danach mit.",
      "joinsNextTurn": "Der Agent arbeitet. Ihre Nachricht wartet und geht mit seinem nächsten Zug mit.",
      "runsWhenYouHost": "Läuft auf Ihrem eigenen Agenten, sobald dieser Durchlauf auf Ihrem PC läuft.",
      "waitsForHost": "Der Agent antwortet, sobald der DMW Connector des PCs, auf dem der Durchlauf läuft, online ist."
    },
    "placeholder": "Nachricht an den Agenten. @ fügt Dokumente, Artefakte, Werkzeuge und Ihre Erinnerungen ein; / fügt Skills und Prompts ein.",
    "queue": "Für den Agenten einreihen",
    "send": "Senden",
    "suggestions": {
      "kinds": {
        "artifact": "Artefakt",
        "document": "Dokument",
        "memory": "Erinnerung",
        "prompt": "Prompt-Vorlage",
        "skill": "Skill",
        "tool": "Werkzeug"
      },
      "label": "Vorschläge",
      "someFailed": "Einige Vorschläge konnten nicht geladen werden."
    },
    "toolRun": {
      "loading": "Das Werkzeug wird gelesen…",
      "notJson": "Geben Sie den Wert als JSON ein.",
      "open": "{{tool}} selbst ausführen…",
      "run": "{{tool}} ausführen"
    }
  },
  "current": {
    "cancelEdit": "Abbrechen",
    "change": "Schritt ändern",
    "edit": "Diesen Schritt bearbeiten…",
    "editAndTryAgain": "Bearbeiten und erneut versuchen…",
    "editQuestion": "Ein geänderter Schritt ergibt eine neue Version des Prozessschemas. Dieses Prozessschema aktualisieren oder ein abgeleitetes Prozessschema speichern?",
    "entry": {
      "hostChooses": "Die Person, auf deren PC der Durchlauf läuft, wählt das Dokument oder Segment.",
      "noCorpus": "Dieser Durchlauf hat kein Korpus, aus dem Sie ein Dokument oder Segment wählen könnten.",
      "question": "Welches Dokument oder Segment?"
    },
    "failed": "Dieser Versuch ist fehlgeschlagen; das Problem steht oben im Verlauf. Nichts wird von selbst wiederholt.",
    "failedAgent": "Dieser Versuch ist fehlgeschlagen; das Problem steht oben im Verlauf. Ein Aufruf, der den Anbieter erreicht haben kann, wird nie von selbst wiederholt. Prüfen Sie also den Verlauf, bevor Sie es erneut versuchen.",
    "filled": "Automatisch ausgefüllt ({{count}})",
    "inputs": {
      "changed": "Für diesen Durchlauf geändert",
      "choose": "Auswählen…",
      "chooseFor": "Element für {{name}} auswählen",
      "chooseSearch": "Element in der Bibliothek finden",
      "optional": "optional",
      "required": "erforderlich",
      "reset": "Zurücksetzen",
      "results": {
        "choose": "Wählen Sie ein Ergebnis aus.",
        "loading": "Zu entscheidende Ergebnisse werden geladen…",
        "none": "Kein Ergebnis wartet auf Ihre Entscheidung."
      }
    },
    "label": "Aktueller Schritt",
    "newStep": "Neuer Schritt…",
    "recoveryStep": "Einen Wiederherstellungsschritt verwenden…",
    "run": "Ausführen",
    "runAgain": "Erneut ausführen ab …",
    "runAgainFrom": "Erneut ab „{{step}}“ ausführen",
    "runSavedNotHost": "Solange dieser Durchlauf nicht verbunden ist, kann nur die Person, auf deren PC er läuft, diesen Schritt ausführen. Führen Sie ihn auf Ihrem PC aus, um den Schritt selbst auszuführen.",
    "skip": "Überspringen",
    "swap": "Gegen einen anderen Schritt tauschen…",
    "tryAgain": "Erneut versuchen"
  },
  "editStep": {"noItem": "Dieser Bearbeitungsschritt nennt kein Element zum Bearbeiten."},
  "entry": {
    "agent": "Agent",
    "agentOf": "Agent von {{name}}",
    "copyReference": "Referenz {{reference}} kopieren",
    "forkHere": "Bei Eintrag #{{number}} forken",
    "system": "DMW",
    "waitsForSender": "Wartet, bis {{name}} übernimmt und sie auf dem eigenen Agenten ausführt.",
    "waitsForYou": "Wartet, bis dieser Durchlauf auf Ihrem PC läuft und Ihr eigener Agent sie ausführt."
  },
  "events": {
    "acceptForkOffer": "Hier forken",
    "continuesWith": "Weiter mit Schritt {{step}}.",
    "forkOffered": "Fork bei #{{entry}} an {{user}} angeboten.",
    "forkedBy": "Geforkt durch {{user}} aus",
    "free": "Ohne Prozessschema.",
    "fromOffer": "wie in #{{entry}} angeboten",
    "hostChanged": "Läuft jetzt auf dem PC von {{to}}, vorher auf dem PC von {{from}}.",
    "hosting": {
      "closed": "Geschlossen",
      "reopened": "Wieder geöffnet",
      "saved": "Nicht verbunden",
      "went_live": "Verbunden"
    },
    "hostingLine": "{{change}}: {{reason}}",
    "hostingReasons": {
      "attached": "ein DMW Connector wurde verbunden",
      "closed_by_participant": "geschlossen",
      "connector_offline": "der DMW Connector ging offline",
      "connector_returned": "der DMW Connector ist zurück",
      "connector_revoked": "der DMW Connector wurde widerrufen",
      "detached": "der DMW Connector wurde getrennt",
      "hand_off": "Übergabe",
      "reopened_by_host": "von der Person wieder geöffnet, auf deren PC er läuft"
    },
    "noRoute": "keinen Agenten",
    "outcome": {
      "merge": "{{by}} hat den Änderungssatz übernommen.",
      "reopen": "{{by}} hat den Änderungssatz wieder geöffnet.",
      "resubmit": "{{by}} hat den Änderungssatz erneut eingereicht.",
      "scrap": "{{by}} hat den Änderungssatz verworfen.",
      "send_back": "{{by}} hat den Änderungssatz zurückgegeben."
    },
    "problem": "Problem",
    "settingsChanged": "Einstellungen geändert: läuft mit {{route}}, Profil {{profile}}.",
    "started": "„{{title}}“ gestartet.",
    "titleChanged": "{{user}} hat den Durchlauf in „{{title}}“ umbenannt.",
    "withSomeWorkflow": "Mit einem Prozessschema.",
    "withWorkflow": "Mit Prozessschema „{{workflow}}“.",
    "workflow": {
      "completed": "Prozessschema abgeschlossen.",
      "left": "Prozessschema verlassen; das Gespräch geht frei weiter.",
      "resumed": "Zurück im Prozessschema.",
      "runToStopped": "Durchlauf bis zu einem Schritt angehalten.",
      "run_to": "Der Durchlauf läuft bis „{{step}}“.",
      "skipped": "Schritt {{step}} übersprungen.",
      "skippedOnTheWay": "„{{step}}“ unterwegs übersprungen: der Durchlauf braucht ihn nicht.",
      "started": "Prozessschema {{workflow}} gestartet.",
      "switched": "Von „{{from}}“ zu „{{to}}“ gewechselt, nach „{{step}}“.",
      "switchedUnsettled": "Von „{{from}}“ zu „{{to}}“ gewechselt."
    }
  },
  "fork": {
    "atLatest": "Forken",
    "atThisEntry": "Wie bei diesem Eintrag",
    "corpusVersion": "Korpusversion",
    "corpusVersionDetail": "Mit einer anderen Version arbeitet der Fork mit dem Dokument, wie es dort ist, und seine Schritte beginnen wieder beim ersten. Der Verlauf bis hier bleibt.",
    "defaultTitle": "{{title}} (Fork bei #{{entry}})",
    "explanation": "Arbeiten Sie ab hier in einer Kopie des bisherigen Verlaufs weiter, die auf Ihrem PC läuft.",
    "loadingPoint": "Die Versionen bei diesem Eintrag werden gelesen …",
    "onNewest": "Den Fork mit der neuesten Inhaltsversion und der neuesten Version dieses Prozessschemas ausführen",
    "onNewestDetail": "Übernommene Änderungen an Schritten, Prompts und Labels gelten im Fork. Schritte vor dem ersten geänderten behalten ihre Ergebnisse, und der Fork macht dort weiter.",
    "preview": {
      "continues": "läuft ab hier",
      "failed": "fehlgeschlagen; Sie können ihn erneut ausführen",
      "kept": "behält sein Ergebnis",
      "later": "läuft danach",
      "loading": "Es wird ermittelt, was der Fork behält …",
      "olderVersion": "Erstellt mit einer älteren Version von",
      "title": "Was der Fork behält",
      "unnamedStep": "Ein Schritt",
      "waiting": "wartet wie zuvor auf seine Antwort"
    },
    "questionsTitle": "Fragen aus {{title}}",
    "submit": "Forken",
    "title": "Bei Eintrag #{{entry}} forken",
    "toQuestions": "Kompetenzfragen aus diesen Einträgen entwerfen",
    "toQuestionsDetail": "Aus den hier gesichteten Annotationen, auf der neuesten Inhaltsversion."
  },
  "handOff": {
    "copyLink": "Link kopieren",
    "forkOfferedBody": "Das Angebot steht im Durchlauf; die Person kann dort mit einem Schritt forken.",
    "forkOfferedTitle": "Fork angeboten",
    "kinds": {
      "fork": {
        "description": "Die Person bekommt ab hier eine eigene Kopie, die auf ihrem PC läuft. Dieser Durchlauf bleibt Ihrer.",
        "title": "Fork bei #{{entry}} anbieten"
      },
      "hostRole": {
        "description": "Nach der Annahme läuft der Agent auf dem PC der Person mit deren Konto.",
        "title": "Auf ihrem PC laufen lassen"
      }
    },
    "noMembers": "Dieses Projekt hat keine weiteren Mitglieder, an die Sie übergeben können.",
    "offerLinkHint": "{{recipient}} findet das Angebot im Durchlauf-Eingang. Sie können auch diesen Link schicken. Er läuft ab {{expires}}.",
    "offerStates": {
      "accepted": "Angebot angenommen",
      "declined": "Angebot abgelehnt",
      "expired": "Angebot abgelaufen",
      "pending": "Angebot gesendet",
      "withdrawn": "Angebot zurückgezogen"
    },
    "pendingOffer": "An {{recipient}}, läuft ab {{expires}}",
    "pendingTitle": "Ihre offenen Angebote",
    "recipient": "An",
    "send": "Anbieten",
    "title": "Übergeben",
    "withdraw": "Zurückziehen"
  },
  "header": {
    "askAgain": "Erneut fragen",
    "asked": "{{host}} wurde um die Übergabe gebeten.",
    "change": "Ändern",
    "chooseWhere": "Wählen, wo er läuft …",
    "decline": "Ablehnen",
    "forkAndRun": "Forken und selbst ausführen",
    "forkOf": "Fork von",
    "forkOfEntry": "dem ursprünglichen Durchlauf, bei #{{number}}",
    "forks_one": "{{count}} Fork:",
    "forks_other": "{{count}} Forks:",
    "handOver": "Übergeben",
    "importedExample": "Beispieldurchlauf, aufgezeichnet am {{date}} mit {{model}}. Hier läuft nichts erneut.",
    "noConnector": "Keiner Ihrer DMW Connectors ist online.",
    "notHandedOver": "{{host}} hat ihn nicht übergeben.",
    "notRunning": "Läuft nicht.",
    "notRunningTheirs": "Läuft nicht: Der PC von {{host}} ist offline.",
    "referenceHint": "Diese Referenz kopieren, um den Durchlauf in seinem jetzigen Stand zu zitieren.",
    "requestFrom": "{{name}} möchte diesen Durchlauf auf dem eigenen PC ausführen.",
    "runOn": "Auf {{place}} ausführen",
    "runsOn": "Läuft auf: {{place}}",
    "runsOnAnotherPc": "Läuft auf: {{place}}, nicht auf diesem PC",
    "stepsDiffer_one": "{{count}} Schritt weicht ab",
    "stepsDiffer_other": "{{count}} Schritte weichen ab",
    "takeOver": "Auf Ihrem PC ausführen",
    "theirPc": "PC von {{host}}",
    "withdraw": "Zurückziehen",
    "workflow": "Prozessschema: {{name}}",
    "yourPc": "Ihrem PC"
  },
  "hostOffer": {
    "accept": "Auf Ihrem PC ausführen",
    "decline": "Ablehnen",
    "explanation": "Sein Agent läuft dann auf Ihrem PC und mit Ihrem Abonnement, für alle in diesem Durchlauf.",
    "title": "{{host}} bietet an, ihn auf Ihrem PC laufen zu lassen"
  },
  "hosting": {
    "approvalBlocksMove": "{{tools}} wartet auf Freigabe. Im Durchlauf beantworten oder abbrechen, dann erneut versuchen.",
    "attach": "Verbinden",
    "attachSubtitle": "Der Agent läuft auf Ihrem PC, über Ihren DMW Connector, für alle in diesem Durchlauf.",
    "attachTitle": "Wo er läuft",
    "capabilities": {
      "context_tokens": "Kontextgröße",
      "image_input": "Bildeingabe",
      "reasoning": "Reasoning",
      "skills": "Skills",
      "text": "Text",
      "tools": "Tools"
    },
    "capabilityHint": "DMW prüft je Schritt, ob das LLM kann, was der Schritt braucht, und sagt es im Durchlauf, wenn nicht.",
    "checkAgain": "Erneut prüfen",
    "connector": "DMW Connector",
    "connectorsLink": "Ihre DMW Connectors",
    "facts": {
      "assert": "{{capability}} für dieses Projekt festhalten…",
      "assertHint": "Halten Sie die Einschätzung Ihres Teams in einer Fähigkeitskorrektur zum Review fest.",
      "capability": "Fähigkeit",
      "conflict": "unbekannt: Korrekturen widersprechen sich",
      "disagrees": "auch {{value}} laut",
      "no": "nein",
      "none": "Noch nichts: Weder der Agent noch der Anbieter hat gesagt, was dieses LLM kann.",
      "openOverride": "Korrektur",
      "outsideVocabulary": "Vom Anbieter gemeldet; nicht im Fähigkeitsvokabular von DMW, daher kann noch kein Schritt es verlangen.",
      "probeHint": "Oder testen Sie es auf Ihrem PC (eine kleine Anfrage, die der Anbieter berechnen kann):",
      "refresh": "Auf diesem PC neu prüfen",
      "refreshHint": "Liest die LLMs und LLM-Kataloge der Agenten und die LLM-Listen der APIs neu; kein LLM wird etwas gefragt.",
      "refreshing": "PC gefragt; die Angaben werden aktualisiert, sobald er antwortet.",
      "source": "Herkunft",
      "sources": {
        "observed": "In Turns gesehen",
        "override_host": "connector.toml auf dem PC, auf dem er läuft",
        "override_installation": "Korrektur der Installation",
        "override_project": "Korrektur des Projekts",
        "probed": "Getestet",
        "reported": "Gemeldet"
      },
      "title_one": "Was DMW über dieses LLM weiß ({{count}} Fakt)",
      "title_other": "Was DMW über dieses LLM weiß ({{count}} Fakten)",
      "value": "Wert",
      "yes": "ja"
    },
    "fallback": {
      "add": "Hinzufügen",
      "chooseRoute": "Ausweichroute hinzufügen…",
      "down": "Ausweichroute {{position}} nach unten",
      "help": "Wird der Schlüssel der eigenen LLM-Route eines Zuges abgelehnt oder ist ihr Guthaben aufgebraucht, läuft er auf der ersten dieser LLM-Routen, die funktioniert. Eine andere LLM-Route kann ein anderes Konto belasten.",
      "isOwn": "Das ist die eigene LLM-Route des Durchlaufs.",
      "none": "Keine: Ein Zug läuft auf seiner eigenen LLM-Route oder gar nicht.",
      "remove": "Ausweichroute {{position}} entfernen",
      "removeShort": "Entfernen",
      "title": "Ausweichrouten, in Reihenfolge",
      "up": "Ausweichroute {{position}} nach oben"
    },
    "fit": {
      "defaultToolsDropped": "Diese LLM-Route hat keine Werkzeuge, daher beginnen Antworten in diesem Durchlauf ohne die Erinnerungswerkzeuge.",
      "fits": "Dieses LLM kann, was jeder Turn dieses Durchlaufs verlangt.",
      "hint": "dieser Agent hat etwa {{value}} gemeldet; DMW kann es nicht bestätigen",
      "lacksTitle": "Dieses LLM kann nicht jeden Turn dieses Durchlaufs ausführen",
      "no": "kein {{capability}}",
      "notChecked": "DMW konnte die LLMs gerade nicht prüfen; es prüft jeden Schritt, wenn er läuft.",
      "replyTurns": "Antworten",
      "step": "Schritt {{step}}",
      "uncertainTitle": "Dieses LLM kann diesen Durchlauf ausführen; DMW weiß noch nicht alles, was er braucht",
      "unknown": "{{capability}} unbekannt",
      "unknownExplained": "Die Züge können mit unbekannten Fähigkeiten laufen. Halten Sie die Einschätzung Ihres Teams in einer Fähigkeitskorrektur fest."
    },
    "loadingConnectors": "Ihre DMW Connectors werden geladen …",
    "noAgents": "Dieser DMW Connector meldet keine Agenten.",
    "noneOnlineBody": "Ihre gekoppelten DMW Connectors laufen nicht. Starten Sie einen auf Ihrem PC und prüfen Sie dann erneut:",
    "noneOnlineTitle": "Kein DMW Connector online",
    "nonePairedBody": "Ein Durchlauf führt seinen Agenten über den DMW Connector auf Ihrem PC aus. Installieren Sie ihn und koppeln Sie ihn mit diesem Konto:",
    "nonePairedTitle": "Kein DMW Connector gekoppelt",
    "online": "online",
    "pairLink": "DMW Connector koppeln",
    "profile": "Berechtigungsprofil",
    "unavailable": {
      "blocked": "Schlüssel abgelehnt oder kein Guthaben",
      "failed": "funktioniert nicht",
      "model_unavailable": "dieses LLM wird nicht angeboten",
      "no_key": "kein API-Schlüssel",
      "not_installed": "nicht installiert",
      "not_logged_in": "nicht angemeldet"
    },
    "workspaceProfileChosen": "Schritt {{steps}} liest eine Datei aus Ihrem Arbeitsordner: Dieses Profil öffnet ihn für freigegebene Werkzeuge.",
    "workspaceProfileMissing": "Schritt {{steps}} liest eine Datei aus Ihrem Arbeitsordner, aber dieses Profil öffnet ihn nicht für Werkzeuge. Wählen Sie ein Profil mit item_tools_workspace; `just connector-status` listet sie auf."
  },
  "humanStep": {
    "answerInCurrentStep": "Beantworte ihn im aktuellen Schritt, über dem Nachrichtenfeld.",
    "answered": "Antwortet auf #{{entry}}",
    "choose": "Ihre Wahl",
    "chose": "hat {{choice}} gewählt",
    "comment": "Kommentar (optional)",
    "commentRequired": "Kommentar (erforderlich)",
    "confirm": "Bestätigen",
    "confirmedResult": "hat das gesichtete Ergebnis bestätigt",
    "editedResult": "hat das gesichtete Ergebnis bearbeitet",
    "inCurrentStep": "Die Eingaben stehen im aktuellen Schritt.",
    "requested": "Fragt eine beteiligte Person:",
    "reviewAnnotationsHint": "Markieren Sie Text, um eine Annotation hinzuzufügen, oder wählen Sie eine Annotation im Text, um ihr Label zu ändern oder sie zu entfernen. Um eine Spanne zu ändern, entfernen Sie sie und markieren Sie den richtigen Text. Bestätigen Sie die Annotationen unverändert oder senden Sie Ihre Änderungen.",
    "reviewHint": "Bestätigen Sie es so, wie es ist, bei Bedarf mit Kommentar.",
    "send": "Antworten",
    "sentResult": "hat das gesichtete Ergebnis gesendet",
    "sentSet": "Annotationen, wie gesendet",
    "submitEdited": "Änderungen senden",
    "superseded": "Durch ein neueres Ergebnis ersetzt. Der Schritt wird erneut gefragt, sobald der frühere Schritt gelaufen ist; eine Antwort hier ändert nichts.",
    "title": "{{kind}} {{step}}",
    "workspaceFile": "Pfad der Datei in Ihrem Arbeitsordner ({{suffixes}})",
    "workspaceFileHint": "Relativ zu dem Arbeitsordner, den Ihr DMW Connector für Werkzeuge öffnet. Die Datei bleibt auf Ihrem PC; der nächste Schritt liest sie dort und hält ihre SHA-256 fest."
  },
  "inbox": {
    "badge_one": "{{count}} Durchlauf für Ihren PC angeboten",
    "badge_other": "{{count}} Durchläufe für Ihren PC angeboten",
    "expires": "Läuft ab {{expires}}",
    "hostOffer": "{{from}} bietet an, „{{title}}“ auf Ihrem PC auszuführen",
    "hostRequest": "{{from}} möchte „{{title}}“ auf dem eigenen PC ausführen",
    "title": "Angebote für Sie",
    "toolEffect": "Werkzeugfreigabe · {{tool}} auf {{pc}} ausführen"
  },
  "list": {
    "chooseProject": "Wählen Sie ein Projekt, um seine Durchläufe zu sehen.",
    "empty": "Noch keine Durchläufe.",
    "fork": "Fork",
    "placement": {
      "custom": "Andere Zeit",
      "dropToPin": "Zum Anheften hier ablegen",
      "pin": "Anheften",
      "pinned": "Angeheftet",
      "presets": {
        "evening": "Heute Abend",
        "hour": "In 1 Stunde",
        "nextWeek": "Nächste Woche",
        "threeHours": "In 3 Stunden",
        "tomorrow": "Morgen"
      },
      "settle": "Archivieren",
      "settleTitle": "Archivieren: aus der Liste nehmen, bis Sie ihn zurückholen",
      "settled": "Archiviert ({{count}})",
      "shared": "Geteilt ({{count}})",
      "snooze": "Zurückstellen",
      "snoozeMenu": "„{{title}}“ zurückstellen",
      "snoozed": "Zurückgestellt ({{count}})",
      "snoozedUntil": "bis {{time}}",
      "unpin": "Lösen",
      "unsettle": "Zurückholen",
      "wake": "Jetzt wecken",
      "woke": "Geweckt",
      "wokeTitle": "Die Zurückstellung ist vorbei. Öffnen blendet das aus.",
      "working": "Arbeitet ({{count}})"
    },
    "title": "Durchläufe",
    "unread": "Neue Einträge"
  },
  "llm": {
    "choose": "Wählen",
    "chooseUnderRunsWith": "Unter „Läuft mit“ wählen",
    "chosen": "Gewählt",
    "default": "Standard",
    "defaultNamed": "Standard ({{model}})",
    "effort": "Denkaufwand",
    "list": "LLMs",
    "loading": "LLMs werden geladen…",
    "noMatch": "Kein LLM passt.",
    "noStars": "Noch keine LLMs mit Stern. Markieren Sie eins unter Alle.",
    "notChosen": "Noch kein LLM gewählt",
    "notOffered": "{{pc}}: {{reason}}. Wählen Sie ein anderes.",
    "ownForStep": "Eigenes LLM für diesen Schritt",
    "search": "LLMs suchen",
    "seen": "Gesehen {{time}}",
    "show": "Anzeigen",
    "star": "{{model}} mit Stern markieren",
    "tabs": {"all": "Alle", "starred": "Mit Stern"},
    "threadDefault": "Standard des Durchlaufs",
    "unstar": "Stern von {{model}} entfernen",
    "useThreadDefault": "Standard des Durchlaufs verwenden"
  },
  "log": {
    "earlier_one": "{{count}} früheren Eintrag zeigen",
    "earlier_other": "Frühere Einträge zeigen ({{count}} davor)",
    "label": "Einträge",
    "loading": "Einträge werden geladen …",
    "orderBrokenBody_one": "Der Server hat einen Eintrag in falscher Reihenfolge oder doppelt geschickt. Er steht an seinem richtigen Platz; bitte melden Sie das.",
    "orderBrokenBody_other": "Der Server hat {{count}} Einträge in falscher Reihenfolge oder doppelt geschickt. Sie stehen an ihrem richtigen Platz; bitte melden Sie das.",
    "orderBrokenTitle": "Einträge kamen in falscher Reihenfolge",
    "refilling": "Wird nachgeholt …"
  },
  "output": {
    "annotationAdd": "Annotation hinzufügen",
    "annotationDelete": "Annotation löschen",
    "annotationDetails": "Details",
    "annotationDocument": "Dokumentversion",
    "annotationLabel": "Label",
    "annotationLabelList": "Version der Labelliste",
    "annotationsInSegment": "Annotationen in {{segment}}",
    "annotationsInText": "Annotationen im Text",
    "annotationsLoading": "Der annotierte Text wird geladen …",
    "annotationsUnplaced": "Nicht im Text gezeigt:",
    "annotations_one": "{{count}} Annotation von <document/> mit Labels aus <labels/>",
    "annotations_other": "{{count}} Annotationen von <document/> mit Labels aus <labels/>",
    "changeSetProposed": "Hat einen Änderungssatz vorgeschlagen.",
    "instanceDataAbout": "Zu <document/> nach dem Datenmodell <model/>",
    "openReview": "Review öffnen",
    "stepResult": "{{step}}: Ergebnis",
    "title": "Ergebnis des Schritts"
  },
  "page": {"loading": "Durchlauf wird geladen …"},
  "people": {"unknown": "Unbekannte Person", "you": "Sie"},
  "plan": {
    "askedAt": "Braucht {{inputs}} von „{{step}}“: oben bei diesem Schritt ausgefüllt.",
    "askedFor": "Hier abgefragt für „{{step}}“",
    "elseDefault": "Falls nichts kommt: {{value}}",
    "gaveNothing": "„{{step}}“ hat nichts geliefert, daher gilt der Standard",
    "list": "{{first}} und {{last}}",
    "parts": {"notFilled": "Noch nicht ausgefüllt"},
    "producer": {
      "failed": "„{{step}}“ ist fehlgeschlagen und braucht einen neuen Versuch",
      "input": "„{{step}}“ wartet auf eine Antwort",
      "needs": "„{{step}}“ braucht zuerst Eingaben",
      "offline": "„{{step}}“ wartet, bis der PC, auf dem der Durchlauf läuft, wieder verbunden ist",
      "queued": "„{{step}}“ wartet auf den Start",
      "ready": "„{{step}}“ kann jetzt laufen",
      "running": "„{{step}}“ läuft",
      "waiting": "„{{step}}“ wartet auf freie Kapazität",
      "waitingForApproval": "„{{step}}“ wartet auf die Freigabe seines Werkzeugs",
      "waits": "„{{step}}“ wartet auf {{steps}}"
    },
    "prompt": {"label": "Prompt", "source": "Im Schritt vorgeschrieben."},
    "reasons": {
      "abstract_workflow": "Dieses Prozessschema wird nur in einem Prozessschema verwendet, das seine abstrakten Schritte füllt",
      "does_not_resolve": "Die Schritte des Prozessschemas lassen sich nicht auflösen",
      "invalid_value": "„{{input}}“ passt nicht ({{kinds}})",
      "missing_context": "Dieser Durchlauf braucht noch {{kinds}}",
      "missing_input": "„{{input}}“ braucht noch einen Wert",
      "not_a_value_input": "„{{input}}“ nimmt keinen Wert",
      "unknown_input": "„{{input}}“ ist keine Eingabe des Prozessschemas"
    },
    "roles": {
      "abbreviation_table": "Abkürzungstabelle",
      "annotation_guideline": "Annotationsleitfaden",
      "corpus_description": "Korpusbeschreibung",
      "label_list": "Labelliste",
      "publication_target": "Veröffentlichungsziel",
      "reference_vocabularies": "Referenzvokabulare",
      "released_module": "Veröffentlichtes Ontologiemodul",
      "segmentation_rules": "Segmentierungsregeln",
      "term_properties": "Begriffseigenschaften"
    },
    "sources": {
      "carried_output": "Aus einem früheren Prozessschema übernommen",
      "context": "Aus diesem Durchlauf",
      "missing": "Bitte einen Wert eingeben",
      "missingFromThread": "Für diesen Durchlauf nicht gesetzt",
      "projectRole": "{{role}} des Projekts",
      "run_value": "Für diesen Durchlauf eingegeben",
      "step_default": "Standardwert des Schritts",
      "wired_output": "Ergebnis von „{{step}}“",
      "wired_pending": "Wird von „{{step}}“ gefüllt, wenn er läuft",
      "workflow_default": "Standardwert des Prozessschemas"
    },
    "stepCount_one": "{{count}} Schritt",
    "stepCount_other": "{{count}} Schritte",
    "waitsFor": "Wartet auf {{steps}}",
    "wiring": "Die Verknüpfung gibt den Wert weiter, wenn der Schritt läuft."
  },
  "prepare": {
    "author": {
      "about": "Zum Element ({{kind}})",
      "agent": "Mit dem Agenten",
      "agentHint": "Der Agent schlägt Änderungen an dieser Version zum Review vor.",
      "answerHint": "Füllt die erste Antwort, nach der dieses Prozessschema fragt; Sie senden sie dort.",
      "byHand": "Von Hand",
      "byHandHint": "Öffnet das Formular des Elements hier. Speichern schlägt einen Änderungssatz zum Review vor.",
      "byHandNote": "Das Formular öffnet sich in diesem Bereich.",
      "byHandThread": "Füllen Sie das Formular aus und reichen Sie es zum Review ein.",
      "editTitle": "Verbessern: {{name}}",
      "how": "Wie",
      "message": "Erste Nachricht",
      "messageHint": "Wird als erste Nachricht des Durchlaufs gesendet.",
      "newTitle": "Neu: {{name}}",
      "openForm": "Formular öffnen"
    },
    "documents": {
      "chosen_one": "{{count}} Dokument",
      "chosen_other": "{{count}} Dokumente",
      "limit_one": "Eine Arbeit umfasst höchstens {{count}} Dokument.",
      "limit_other": "Eine Arbeit umfasst höchstens {{count}} Dokumente.",
      "overlap": "Dieses Dokument ist schon gewählt, oder es enthält ein gewähltes Segment oder liegt darin.",
      "remove": "{{document}} entfernen",
      "subject": "Gegenstand"
    },
    "earlier": {
      "branch": "Von einem Schritt aus forken…",
      "continue": "Fortsetzen",
      "hint": "Starten Sie unten neu, setzen Sie einen davon fort, oder forken Sie ab einem seiner Schritte. Ein Fork ist ein neuer Durchlauf; der frühere Durchlauf bleibt, wie er ist.",
      "open": "Öffnen",
      "title": "Frühere Läufe auf diesem Dokument",
      "workflow": "Prozessschema"
    },
    "fork": {
      "atEntry": "Eintrag #{{entry}}, wie er ist",
      "beforeStep": "Vor „{{step}}“ (Eintrag #{{entry}})",
      "point": "Forken ab",
      "pointHint": "Übernehmen Sie den Verlauf vor dem letzten Versuch des Schritts und führen Sie den Schritt im Fork erneut aus."
    },
    "invalidBody": "Diese Adresse sagt nicht, was gestartet werden soll. Starten Sie erneut vom Dokument, vom Prozessschema oder von der Durchlauf-Liste aus.",
    "invalidTitle": "Nichts vorzubereiten",
    "memory": {
      "how": "Geben Sie der Erinnerung im nächsten Schritt einen Titel.",
      "noWorkflowBody": "Es hat kein Prozessschema „Eine Erinnerung festhalten“. Binden Sie in den Projekteinstellungen die DMW-Bibliothek ein, die es mitbringt.",
      "noWorkflowTitle": "Dieses Projekt kann noch keine Erinnerungen behalten",
      "threadTitle": "Erinnerung behalten: {{title}}"
    },
    "notYetBody": "Diese Art Arbeit startet noch auf ihrer eigenen Seite. Sie zieht bald in die Durchlauf-Ansicht um.",
    "notYetTitle": "Hier noch nicht vorbereitet",
    "release": {
      "intro": "Wählen Sie Ergebnisse, Ziel und Lizenz und sehen Sie dann die Datenveröffentlichung durch.",
      "noWorkflowBody": "Keines der Prozessschemata dieses Projekts erstellt eine Datenveröffentlichung. Seine Bibliotheksversion ist vielleicht älter als das Prozessschema zur Datenveröffentlichung; ein Bibliotheks-Update bringt es.",
      "noWorkflowTitle": "Kein Prozessschema zur Datenveröffentlichung",
      "threadTitle": "Wissensdaten veröffentlichen"
    },
    "run": {
      "chooseAnother": "Anderes Prozessschema wählen …",
      "chooseEntry": "Wählen Sie das Dokument oder Segment, an dem gearbeitet wird.",
      "chosenMissingBody": "Wählen Sie unten ein Prozessschema oder unter „Versionen“ eine andere Inhaltsversion.",
      "chosenMissingTitle": "Dieser Inhaltsversion fehlt das gewählte Prozessschema",
      "contentVersionHint": "Verwendet standardmäßig die neueste Inhaltsversion.",
      "corpus": "Korpus: {{corpus}} in der neuesten Version.",
      "free": "Ohne Prozessschema",
      "freeHint": "Ein Durchlauf ohne Prozessschema. Schritte können Sie später trotzdem ausführen.",
      "freeTitle": "Neuer Durchlauf",
      "input": "{{label}}",
      "loadingVersions": "Inhaltsversionen werden geladen…",
      "loadingWorkflows": "Prozessschemata werden geladen…",
      "missing": "Zum Starten fehlt {{items}}.",
      "missingEntry": "das Dokument oder Segment, an dem gearbeitet wird",
      "missingLlm": "Zum Starten fehlt ein LLM für seine Agentenschritte.",
      "newThread": "Neuer Durchlauf",
      "newest": "Neueste",
      "noContentBody": "Dieses Projekt ist neu: Es hat noch keine Inhaltsversion und keine Prozessschemata. Starten Sie jetzt einen Durchlauf ohne Prozessschema; das legt die erste, leere Inhaltsversion des Projekts an.",
      "noContentTitle": "Noch keine Prozessschemata",
      "noCorpus": "In Dokumente ist kein Korpus gewählt.",
      "noFittingWorkflows": "Kein Prozessschema dieser Inhaltsversion nimmt diese Dokumente.",
      "noWorkflows": "Diese Inhaltsversion hat keine Prozessschemata.",
      "openWorkflow": "Öffnen",
      "optionalInput": "{{label}} (optional)",
      "preparing": "Was die Schritte des Prozessschemas brauchen, wird geprüft…",
      "quoted": "„{{input}}“",
      "start": "Starten",
      "steps_one": "{{count}} Schritt",
      "steps_other": "{{count}} Schritte",
      "takes": "Nimmt {{inputs}}.",
      "title": "Titel: {{title}}.",
      "titleOnDocument": "{{name}} · {{document}}",
      "titleOnEntries_one": "{{name}} auf {{count}} Dokument",
      "titleOnEntries_other": "{{name}} auf {{count}} Dokumenten",
      "versions": "Versionen",
      "workflow": "Prozessschema",
      "worksOn": "Arbeitet mit"
    },
    "starting": "Wird gestartet…",
    "titles": {
      "author": "Neues Element erstellen",
      "batch": "Auf vielen Dokumenten ausführen",
      "edit": "An einem Element arbeiten",
      "fork": "Diesen Durchlauf forken",
      "import": "Dokumente importieren",
      "memory": "Als Erinnerung behalten",
      "release": "Wissensdaten veröffentlichen",
      "run": "Arbeit starten"
    }
  },
  "progress": {
    "planStatus": {"completed": "Erledigt", "in_progress": "In Arbeit", "pending": "Offen"},
    "toolCalls_one": "{{count}} Werkzeugaufruf",
    "toolCalls_other": "{{count}} Werkzeugaufrufe",
    "toolStatus": {
      "completed": "fertig",
      "failed": "fehlgeschlagen",
      "in_progress": "läuft",
      "pending": "wartet"
    },
    "working": "Der Agent arbeitet …"
  },
  "rename": {"label": "Titel", "save": "Umbenennen", "title": "Umbenennen"},
  "routeNotReady": {
    "not_installed": "{{agent}} ist auf {{pc}} nicht installiert. Richten Sie es dort ein und versuchen Sie es erneut.",
    "not_logged_in": "{{agent}} ist auf {{pc}} nicht angemeldet. Melden Sie sich dort an."
  },
  "runGraph": {
    "count": {
      "annotations_one": "{{count}} Annotation",
      "annotations_other": "{{count}} Annotationen",
      "instance_data_one": "{{count}} Aussage",
      "instance_data_other": "{{count}} Aussagen",
      "other_one": "{{count}} Element",
      "other_other": "{{count}} Elemente",
      "text_units_one": "{{count}} Texteinheit",
      "text_units_other": "{{count}} Texteinheiten"
    },
    "groupSettled": "{{settled}} von {{steps}} Schritten erledigt",
    "label": "Graph des Durchlaufs",
    "noWorkflow": "Kein Prozessschema",
    "openRun": "Den Durchlauf daneben öffnen",
    "tabTitle": "Graph des Durchlaufs: {{title}}",
    "workflow": "Prozessschema: {{name}}"
  },
  "search": {
    "entry": "Durchlauf-Eintrag #{{number}}",
    "label": "Durchläufe durchsuchen",
    "none": "Nichts passt zu „{{query}}“.",
    "placeholder": "Durchläufe durchsuchen …",
    "results": "Suchergebnisse",
    "searching": "Suche läuft …",
    "titleMatch": "Titel"
  },
  "start": {
    "coreReadOnly": "Dies ist DMWs eigenes Projekt. Vorerst kann es nur gelesen werden, deshalb lässt sich hier nichts starten. Beginnen Sie Ihre Arbeit in <projects>einem Ihrer Projekte</projects>."
  },
  "status": {
    "approval": {
      "explanation": "Ein Werkzeug wartet auf die Freigabe durch die Person, der der PC gehört, auf dem der Durchlauf läuft. Sein Schritt läuft, sobald es freigegeben ist.",
      "label": "Freigabe ausstehend"
    },
    "closed": {"explanation": "Nur lesbar. Forken geht weiterhin.", "label": "Geschlossen"},
    "failed": {
      "explanation": "Der letzte Zug oder ein Schritt ist fehlgeschlagen. Öffnen Sie den Durchlauf, um zu sehen, warum.",
      "label": "Fehlgeschlagen"
    },
    "input": {
      "explanation": "Ein Personenschritt wartet auf die Antwort einer beteiligten Person.",
      "label": "Eingabe"
    },
    "live": {
      "explanation": "Der DMW Connector des PCs, auf dem er läuft, ist online; der Agent kann antworten.",
      "label": "Verbunden"
    },
    "saved": {
      "explanation": "Gerade führt kein DMW Connector diesen Durchlauf aus. Nur die Person, auf deren PC er läuft, kann schreiben; andere können ihn forken.",
      "label": "Nicht verbunden"
    },
    "waiting": {
      "explanation": "Sein Zug wartet auf freie Kapazität auf dem PC, auf dem er läuft, und startet von selbst, sobald sie da ist.",
      "label": "Wartet"
    },
    "working": {"explanation": "Der Agent arbeitet an einem Zug.", "label": "Arbeitet"}
  },
  "stepStates": {
    "done": "Erledigt",
    "failed": "Fehlgeschlagen",
    "input": "Eingabe",
    "offline": "PC offline",
    "queued": "Wartet auf den Start",
    "ready": "Bereit",
    "running": "Läuft",
    "skipped": "Übersprungen",
    "upcoming": "Anstehend",
    "waiting": "Wartet",
    "waitingForApproval": "Wartet auf Freigabe"
  },
  "steps": {
    "before_one": "{{count}} Schritt davor",
    "before_other": "{{count}} Schritte davor",
    "bindingsName": "Projektbindungen",
    "boundBy": "{{slot}}: {{role}} des Projekts",
    "changeBound": "Ändern",
    "changeBoundHint": "Andere Elemente für {{items}} in den Bindungen des Projekts wählen",
    "label": "Schritte des Prozessschemas",
    "openRun": "Den Graph des Durchlaufs daneben öffnen",
    "reads": "Liest",
    "runAll": "Alle ausführen",
    "runToHere": "Bis hier ausführen",
    "runningTo": "Läuft bis {{step}}",
    "skips": "Überspringt {{steps}}",
    "stop": "Anhalten",
    "stopBeforeAgentSteps": "Vor Agentenschritten anhalten",
    "takes": "Nimmt {{inputs}}",
    "technical": "Prompt und Verknüpfung"
  },
  "switch": {
    "attach": "Prozessschema wählen…",
    "batchItem": "Dieser Durchlauf gehört zu einer Stapelverarbeitung und behält deren Prozessschema.",
    "busy": "Laufenden Schritt zuerst abschließen oder abbrechen.",
    "confirm": "Zu „{{workflow}}“ wechseln",
    "earlier": "„{{workflow}}“, verlassen nach „{{step}}“",
    "earlierUnsettled": "„{{workflow}}“, verlassen",
    "madeBy": "{{kind}} aus „{{step}}“",
    "madeChoice": "{{made}} · #{{entry}}: {{preview}}",
    "made_one": "Bisheriges Ergebnis · {{count}}",
    "made_other": "Bisherige Ergebnisse · {{count}}",
    "missingNow": "Jetzt fehlt: {{inputs}}",
    "neededLater": "Später benötigt: {{inputs}}",
    "none": "Kein Prozessschema verwendet diese Ergebnisse.",
    "open": "Prozessschema wechseln…",
    "outputFor": "Ergebnis für „{{input}}“",
    "someWorkflow": "ein anderes Prozessschema",
    "switching": "Wechselt…",
    "uses": "Verwendet {{outputs}}",
    "withdraws": "Der Wechsel zieht die Anfrage zurück, die auf eine Antwort wartet."
  },
  "takeOver": {
    "ask": "{{host}} fragen",
    "explanation": "{{host}} bestätigt mit einem Klick. Sein Agent läuft dann auf Ihrem PC und mit Ihrem Abonnement, für alle in diesem Durchlauf.",
    "title": "Auf Ihrem PC statt auf dem PC von {{host}} ausführen?"
  },
  "talk": {
    "answered": "Der Agent antwortete:",
    "asked": "Ihre Frage:",
    "cancel": "Abbrechen",
    "noAnswer": "Der Agent gab keine Antwort.",
    "open": "Mit dem Agenten sprechen",
    "renews": {
      "annotations": "Der Agent antwortet und kann die Annotationen überarbeiten; das Review beginnt dann mit seinem Ergebnis neu.",
      "instance_data": "Der Agent antwortet und kann die Aussagen überarbeiten; das Review beginnt dann mit seinem Ergebnis neu.",
      "result": "Der Agent antwortet und kann das Ergebnis überarbeiten; das Review beginnt dann mit seinem Ergebnis neu."
    },
    "request": "Ihre Frage oder Bitte an den Agenten",
    "send": "An den Agenten senden"
  },
  "toolApproval": {
    "agentsTool": "Ein Werkzeug, das der Agent angefordert hat",
    "answer": "Autor, Reviewer, Laufzeit und Abhängigkeiten prüfen, dann y eingeben, um freizugeben.",
    "answerHere": "Antworten Sie hier oder auf {{pc}}; die erste Antwort zählt. Der Schritt läuft von selbst, sobald es freigegeben ist.",
    "apiEmbedding": "Über eine API",
    "approve": "Freigeben",
    "authorOnly": "Von {{author}}; ohne Review durch andere.",
    "byReviewed": "Von {{author}}, Review von {{reviewers}}.",
    "copyCommand": "Befehl kopieren",
    "copyVersion": "Werkzeugversion kopieren",
    "decline": "Ablehnen",
    "dependenciesNone": "Keine",
    "detailDependencies": "Abhängigkeiten",
    "detailLimits": "Grenzen",
    "detailModel": "Embedding-Modell",
    "detailReads": "Liest",
    "detailRuntime": "Laufzeit",
    "detailVersion": "Version",
    "details": "Details",
    "hostPc": "dem PC, auf dem der Durchlauf läuft",
    "inTerminal": "In einem Terminal auf diesem PC:",
    "limits": "{{seconds}} s, {{memory}} MB Speicher, {{output}} MB Ausgabe",
    "localEmbedding": "Lokal",
    "message": "Diese neue Werkzeugversion erlaubt nur die Person, der der PC gehört, auf dem der Durchlauf läuft: einmal, auf der Freigabeseite dieses PCs.",
    "nodeOnly": "Nur die eingebauten Module von Node",
    "notThisPc": "Läuft auf {{pc}}, nicht auf diesem PC.",
    "openApprovalsOn": "Freigaben auf {{pc}} öffnen",
    "outcomes": {
      "approved": "Freigegeben. {{pc}} führt den Schritt jetzt aus.",
      "declined": "Abgelehnt. Der Schritt läuft nicht auf {{pc}}.",
      "expired": "Diese Anfrage ist abgelaufen. Sie kommt wieder, wenn der Schritt erneut fragt.",
      "noAnswer": "{{pc}} hat nicht geantwortet. Versuchen Sie es erneut oder antworten Sie auf {{pc}}.",
      "notOwner": "Nur das Konto, mit dem {{pc}} gekoppelt ist, kann antworten.",
      "notPending": "Schon beantwortet, auf {{pc}} oder hier; nichts geändert.",
      "off": "{{pc}} nimmt Antworten nur auf seiner eigenen Seite an.",
      "updateNeeded": "Aktualisieren Sie den DMW Connector auf {{pc}}, um hier zu antworten; bis dahin antworten Sie auf {{pc}}."
    },
    "readsSources": "die Quelldokumente des Projekts",
    "reviewedBy": "Review von {{reviewers}}.",
    "serverDefaults": "Die Vorgaben des Servers",
    "title": "{{tool}} auf dem PC freigeben, auf dem der Durchlauf läuft",
    "unknownVouch": "Wer es geschrieben und wer das Review gemacht hat, ist nicht bekannt.",
    "useCommand": "Stattdessen einen Befehl verwenden",
    "version": "Werkzeug {{tool}}, Version {{version}}",
    "waiting": "Wartet auf Freigabe auf {{pc}}. Danach läuft der Schritt automatisch.",
    "wantsToRun": "{{tool}} möchte auf {{pc}} laufen"
  },
  "toolCall": {
    "failed": "{{tool}} fehlgeschlagen: {{reason}}",
    "failureStatus": "Fehlgeschlagen",
    "generic": "{{tool}} aufgerufen",
    "input": "Eingabe",
    "ok": "Erfolgreich",
    "output": "Ausgabe",
    "summary": "Werkzeug {{tool}}: {{outcome}}, {{milliseconds}} ms"
  },
  "toolCalls": {
    "count_one": "{{count}} Werkzeugaufruf",
    "count_other": "{{count}} Werkzeugaufrufe",
    "failed_one": "{{count}} fehlgeschlagen",
    "failed_other": "{{count}} fehlgeschlagen",
    "worked_one": "{{duration}} gearbeitet · {{count}} Werkzeugaufruf",
    "worked_other": "{{duration}} gearbeitet · {{count}} Werkzeugaufrufe"
  },
  "toolStep": {
    "awaitingApproval": "wartet auf Freigabe",
    "checks": {
      "cannotRun_one": "{{count}} konnte nicht laufen",
      "cannotRun_other": "{{count}} konnten nicht laufen",
      "failed_one": "{{count}} fehlgeschlagen",
      "failed_other": "{{count}} fehlgeschlagen",
      "notChecked_one": "{{count}} nicht geprüft",
      "notChecked_other": "{{count}} nicht geprüft",
      "passed_one": "{{count}} bestanden",
      "passed_other": "{{count}} bestanden"
    },
    "code": "Code",
    "codeOf": "Code von {{tool}}",
    "offline": "wartet auf den PC, auf dem der Durchlauf läuft",
    "queued": "wartet auf den Start",
    "running": "läuft…",
    "waitingForSlot": "wartet auf freie Kapazität"
  },
  "toolTurn": {
    "browseTerms": "Im Datenmodell ansehen",
    "byteCount_one": "{{count}} Byte",
    "byteCount_other": "{{count}} Bytes",
    "documents_one": "{{count}} Dokument für das Korpus des Durchlaufs, hochgeladen",
    "documents_other": "{{count}} Dokumente für das Korpus des Durchlaufs, hochgeladen",
    "duration": "Dauer",
    "fileCount_one": "{{count}} Datei",
    "fileCount_other": "{{count}} Dateien",
    "inputFileLabel": "Datei im Arbeitsordner für {{input}}",
    "memoized": "Gespeicherte Ergebnisse wiederverwendet",
    "more_one": "und {{count}} weiteres",
    "more_other": "und {{count}} weitere",
    "newItem": "Neues Element ({{kind}}), zum Review vorzuschlagen",
    "onRuntime": "auf dem DMW Connector ({{runtime}})",
    "onServer": "auf dem Server",
    "openItem": "Das Element öffnen",
    "output": "Ergebnis {{part}}",
    "outputs": "Ergebnisse:",
    "parameters": "Werkzeugparameter",
    "requested": "Werkzeugschritt {{step}} angefordert, {{route}}:",
    "requestedWithoutStep": "Werkzeuglauf angefordert, {{route}}:",
    "score": "Wert {{score}}",
    "sourceVersionSummary": "{{source}} · {{commit}} · {{files}}, {{bytes}}",
    "terms_one": "{{count}} Ontologiebegriff.",
    "terms_other": "{{count}} Ontologiebegriffe.",
    "title": "Werkzeuglauf",
    "value": "Wert anzeigen",
    "valueKinds": {
      "annotations": "Annotationen",
      "change_set": "Änderungssatz",
      "check_report": "Prüfbericht",
      "choice": "Auswahl",
      "corpus_import": "Korpusimport",
      "derived": "Abgeleitete Daten",
      "derived_records": "Abgeleitete Datensätze",
      "html_page": "HTML-Seite",
      "instance_data": "Aussagen",
      "item": "Element",
      "item_refs": "Elementreferenzen",
      "memory": "Erinnerung",
      "release": "Datenveröffentlichung",
      "release_request": "Veröffentlichungsanfrage",
      "result": "Ergebnis",
      "source_version": "Quellversion",
      "term_cards": "Begriffskarten",
      "text": "Text",
      "text_units": "Texteinheiten",
      "workspace_file": "Datei im Arbeitsordner"
    }
  },
  "turn": {
    "agent": "Agent",
    "agentOnly": "Agent {{agent}}",
    "agentRoute": "Agent {{agent}}, {{model}}",
    "agentSetup": {
      "counts": "{{skills}}, {{servers}}, {{files}}",
      "digest": "Prüfsumme der Einrichtung",
      "dmw_only": "Lief nur mit DMW",
      "extend": "Lief mit Ihrer Einrichtung + DMW",
      "files_one": "{{count}} Anweisungsdatei",
      "files_other": "{{count}} Anweisungsdateien",
      "hooks": "Hooks",
      "memory": "Agent-Gedächtnis",
      "memoryRead": "lesen: {{read}}, speichern: aus",
      "memoryStates": {"off": "aus", "on": "an"},
      "personalSkills": "Eigene Skills",
      "plugins": "Plugins",
      "serverLoaded": "{{name}} (geladen)",
      "serverOff": "{{name}} (nicht angehakt, aus)",
      "servers": "MCP-Server",
      "servers_one": "{{count}} MCP-Server",
      "servers_other": "{{count}} MCP-Server",
      "skills_one": "{{count}} eigener Skill",
      "skills_other": "{{count}} eigene Skills",
      "title": "Agent-Einrichtung",
      "tryDmwOnly": "Nur mit DMW versuchen",
      "tryDmwOnlyHelp": "Führt dies erneut aus, ohne Ihre eigenen Anweisungen, Skills, MCP-Server und Plugins, um zu sehen, ob sie den Fehler verursacht haben."
    },
    "answers": "Antwortet auf Anforderung",
    "apiRoute": "API {{route}}, {{model}}",
    "askedAgent": "Den Agenten gefragt: {{what}}",
    "basedOn": "Eingabe berücksichtigt bis",
    "capabilitiesUnknown": "DMW kannte {{capabilities}} des LLM beim Start dieses Turns nicht; er lief trotzdem.",
    "covers": "Übergibt {{entries}}.",
    "defaultModel": "Standard-LLM des Agenten",
    "details": "Details",
    "inputPurposes": {
      "agent_instructions": "Anweisungen an den Agenten",
      "history_preamble": "Bisheriger Verlauf",
      "pending_messages": "Übergebene Nachrichten",
      "step_instructions": "Agentenanweisungen des Schritts",
      "step_prompt": "Prompt des Schritts",
      "turn_note": "Hinweis"
    },
    "localToolCall": "{{title}} ({{kind}}, {{status}})",
    "outcome": "Ergebnis",
    "outcomes": {
      "cancelled": "Abgebrochen",
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen"
    },
    "output": "Ergebnis",
    "permissionProfile": "Berechtigungsprofil",
    "providerContact": "Anbieter erreicht",
    "providerContacts": {"confirmed": "ja", "none": "nein", "possible": "vielleicht"},
    "redacted": "Aus dem Ergebnis wurden Geheimnisse entfernt: {{patterns}}.",
    "reply": "eine Antwort",
    "route": "Läuft mit",
    "session": "Sitzung",
    "sessionModes": {
      "continue": "fortgesetzt",
      "fresh": "neu",
      "isolated": "isoliert",
      "resume": "wieder aufgenommen"
    },
    "talkContinuations": {
      "rebuilt": "Die Sitzung des Agenten ließ sich nicht fortsetzen; er bekam stattdessen den früheren Austausch.",
      "resumed": "In der eigenen Sitzung des Agenten.",
      "thread": "In der Sitzung des Durchlaufs."
    },
    "talked": "Mit dem Agenten von {{what}} gesprochen",
    "tools": "Werkzeuge"
  },
  "turnActivity": {
    "agentsAtOnce_one": "Dort arbeitet höchstens ein Agent gleichzeitig.",
    "agentsAtOnce_other": "Dort arbeiten höchstens {{count}} Agenten gleichzeitig.",
    "awaitingApproval": "Wartet auf die Freigabe seines Werkzeugs",
    "changeAgentsAtOnce": "Auf {{pc}} ändern",
    "fetchingModel": "Lädt das Embedding-Modell",
    "hostOffline": "Wartet, bis der PC, auf dem der Durchlauf läuft, wieder verbunden ist",
    "modelReceived": "{{megabytes}} MB",
    "toolRunning": "Werkzeug läuft",
    "waitingForSlot": "Wartet auf freie Kapazität auf {{pc}}",
    "workDone": "{{done}} von {{total}}"
  },
  "turnStates": {
    "cancelled": "Abgebrochen",
    "cancelling": "Wird abgebrochen",
    "completed": "Abgeschlossen",
    "dispatched": "An den DMW Connector geschickt",
    "failed": "Fehlgeschlagen",
    "queued": "Wartet auf den Start",
    "running": "Agent arbeitet"
  },
  "usage": {
    "cost": "Kosten {{cost}}",
    "summary": "Tokens rein {{input}}, raus {{output}}, zwischengespeichert {{cached}} · Kosten {{cost}}",
    "title": "Verbrauch",
    "tokens": "Tokens ein {{input}}, aus {{output}}, zwischengespeichert {{cached}}",
    "unknown": "unbekannt"
  },
  "versions": {
    "compaction": "Gekürzt",
    "corpusVersion": "Korpusversion",
    "historyPreamble": "Verlaufsmethode",
    "inputEntries": "Eingabe-Einträge",
    "prompt": "Prompt",
    "reduced": "gekürzt, Stufe {{level}}",
    "step": "Schritt",
    "subject": "Dokument",
    "workflow": "Prozessschema"
  },
  "waits": {
    "changeSetCurators": "Wartet auf die Kuration der Änderung.",
    "host": "Wartet auf die Antwort von {{name}}.",
    "memoryOwner": "Wartet auf die Person, der die Erinnerung gehört.",
    "participants": "Wartet auf eine Antwort von jemandem, der in diesem Durchlauf schreiben darf.",
    "resultCurators": "Wartet auf die Kuration des Ergebnisses.",
    "workflowLeft": "Wartet, bis {{name}} das Prozessschema fortsetzt.",
    "workflowLeftHost": "Prozessschema verlassen; dieser Schritt wartet weiter. Setzen Sie das Prozessschema fort, um ihn zu beantworten.",
    "yours": "Wartet auf Ihre Antwort."
  },
  "workflow": {
    "completed": "Abgeschlossen",
    "condition": "{{step}}: {{state}}",
    "conditionState": {"satisfied": "erreicht", "undetermined": "offen", "unsatisfied": "verfehlt"},
    "leave": "Prozessschema verlassen",
    "left": "Verlassen",
    "outcome": {
      "satisfied": "Ziel erreicht",
      "undetermined": "Ziel offen",
      "unsatisfied": "Ziel verfehlt"
    },
    "resume": "Prozessschema fortsetzen",
    "unnamed": "Prozessschema"
  }
}
